// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1581011374549
      var cssReload = require("../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./scss/core/_dropdown-menu-right.scss
// module id = ./scss/core/_dropdown-menu-right.scss
// module chunks = 0